export default {"src":"/_next/static/media/card_check_active.f20a2a6d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};